import PhoneAccessQr from './PhoneAccessQr';

interface LivingRoomQrModalProps {
  titleId: string;
  onClose: () => void;
}

export default function LivingRoomQrModal({
  titleId,
  onClose,
}: LivingRoomQrModalProps) {
  return (
    <div
      className="living-room-qr-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby={titleId}
      onClick={onClose}
    >
      <div
        className="living-room-qr-modal"
        onClick={(event) => event.stopPropagation()}
      >
        <PhoneAccessQr titleId={titleId} />
        <button type="button" className="btn-primary" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
}
